import { Routes } from "@angular/router";
import { AdvisorProfileComponent } from "./modules/advisor-profile/advisor-profile.component";
import { AuthGuard } from "./auth.guard";
import { ViewChatHistoryComponent } from "./modules/view-chat-history/view-chat-history.component";
import { CustomerHoroscopeReportOrderHistoryComponent } from "./modules/customer-horoscope-report-order-history/customer-horoscope-report-order-history.component";
import { CustomerProductOrderHistoryComponent } from "./modules/customer-product-order-history/customer-product-order-history.component";
import { ProductsComponent } from "./modules/products/products.component";
import { ProductDetailComponent } from "./modules/products/product-detail/product-detail.component";
import { ChatWindowComponent } from "./modules/chat-form/chat-window/chat-window.component";
import { PressAndMediaComponent } from "./modules/press-and-media/press-and-media.component";
import { PreloaderComponent } from "./modules/preloader/preloader.component";
import { DashboardLayoutComponent } from "./modules/dashboard/dashboard-layout/dashboard-layout.component";
import { DashboardHomeComponent } from "./modules/dashboard/dashboard-home/dashboard-home.component";
import { AboutUsNewModule } from "./modules/static-pages/about-us-new/about-us-new.module";
import { EventCalenderModule } from "./modules/event-calender/event-calender.module";

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ''
  },

  {
    path: '', loadChildren: () => import('./index/home-page-new/home-page-new.module').then(m => m.HomePageNewModule)
  },

  // ===== Post-login customer dashboard (left-sidebar shell wrapping account pages) =====
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardHomeComponent },
      { path: 'userdetailPage', loadChildren: () => import('./modules/userdetail-page/userdetail-page.module').then(m => m.UserdetailPageModule) },
      { path: 'recharge-wallet', loadChildren: () => import('./modules/addwallet/addwallet.module').then(m => m.AddwalletModule) },
      { path: 'customer-product-order-history', component: CustomerProductOrderHistoryComponent },
      { path: 'customer-transactions-history', loadChildren: () => import('./modules/customer-transaction-history/customer-transaction-history.module').then(m => m.CustomerTransactionHistoryModule) },
      { path: 'customer-chat-order-history', loadChildren: () => import('./modules/customer-chat-order-history/customer-chat-order-history.module').then(m => m.CustomerChatOrderHistoryModule) },
      { path: 'customer-call-order-history', loadChildren: () => import('./modules/customer-call-order-history/customer-call-order-history.module').then(m => m.CustomerCallOrderHistoryModule) },
      { path: 'my-offers', loadChildren: () => import('./modules/offers/offers.module').then(m => m.OffersModule) },
      { path: 'support-chat', loadChildren: () => import('./modules/support-chat/support-chat.module').then(m => m.SupportChatModule) },
    ],
  },

  // {
  //     path: '', component: HomeComponent,
  // },

  { path: 'products/:id', component: ProductsComponent },

  { path: 'products/:id/:id', component: ProductDetailComponent },
  // {
  //     path: 'talk-to-advisor', component: SearchPageComponent,
  // },
  {
    path: 'talk-to-advisor', loadChildren: () => import('./modules/search-page/search-page.module').then(m => m.SearchPageModule)
  },
  {
    path: 'best-advisor/:id', component: AdvisorProfileComponent,
  },

  {
    path: 'service', loadChildren: () => import('./modules/service/service.module').then(m => m.ServiceModule)
  },

  // Fallback for the dashboard home (in case the empty-path layout route is bypassed)
  {
    path: 'dashboard', component: DashboardHomeComponent, canActivate: [AuthGuard]
  },

  {
    path: 'customer-transactions-history', loadChildren: () => import('./modules/customer-transaction-history/customer-transaction-history.module').then(m => m.CustomerTransactionHistoryModule), canActivate: [AuthGuard]
  },

  {
    path: 'customer-chat-order-history', loadChildren: () => import('./modules/customer-chat-order-history/customer-chat-order-history.module').then(m => m.CustomerChatOrderHistoryModule), canActivate: [AuthGuard]
  },
  {
    path: 'viewChatHistory', component: ViewChatHistoryComponent, canActivate: [AuthGuard]
  },

  {
    path: 'customer-call-order-history', loadChildren: () => import('./modules/customer-call-order-history/customer-call-order-history.module').then(m => m.CustomerCallOrderHistoryModule), canActivate: [AuthGuard]
  },
  {
    path: 'customer-horoscope-report-order-history', component: CustomerHoroscopeReportOrderHistoryComponent, canActivate: [AuthGuard]
  },
  {
    path: 'customer-product-order-history', component: CustomerProductOrderHistoryComponent, canActivate: [AuthGuard]
  },

  {
    path: 'recharge-wallet', loadChildren: () => import('./modules/addwallet/addwallet.module').then(m => m.AddwalletModule), canActivate: [AuthGuard]
  },

  {
    path: 'my-offers', loadChildren: () => import('./modules/offers/offers.module').then(m => m.OffersModule), canActivate: [AuthGuard]
  },

  {
    path: 'userdetailPage', loadChildren: () => import('./modules/userdetail-page/userdetail-page.module').then(m => m.UserdetailPageModule), canActivate: [AuthGuard]
  },

  {
    path: 'chat-form', loadChildren: () => import('./modules/chat-form/chat-form.module').then(m => m.ChatFormModule), canActivate: [AuthGuard]
  },

  {
    path: 'contact-us', loadChildren: () => import('./modules/static-pages/contact-us/contact-us.module').then(m => m.ContactUsModule)
  },

  {
    path: 'about-us', loadChildren: () => import('./modules/static-pages/about-us/about-us.module').then(m => m.AboutUsModule)
  },

  {
    path: 'pricing-return-policy', loadChildren: () => import('./modules/static-pages/pricing-return-policy/pricing-return-policy.module').then(m => m.PricingReturnPolicyModule)
  },

  {
    path: 'terms', loadChildren: () => import('./modules/static-pages/terms/terms.module').then(m => m.TermsModule)
  },

  {
    path: 'shipping-policy', loadChildren: () => import('./modules/static-pages/shipping-policy/shipping-policy.module').then(m => m.ShippingPolicyModule)
  },
  {
    path: 'refund', loadChildren: () => import('./modules/static-pages/refund/refund.module').then(m => m.RefundModule)
  },
  {
    path: 'privacy', loadChildren: () => import('./modules/static-pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
  },
  {
    path: 'how-it-works', loadChildren: () => import('./modules/static-pages/how-it-works/how-it-works.module').then(m => m.HowItWorksModule)
  },
  {
    path: 'chat-window', component: ChatWindowComponent
  },
  {
    path: 'preloader', component: PreloaderComponent
  },

  {
    path: 'become-an-advisor', loadChildren: () => import('./advisor-panel/advisor-registration/advisor-registration.module').then(m => m.AdvisorRegistrationModule)
  },
  {
    path: 'partner-user', loadChildren: () => import('./modules/partner-user/partner-user.module').then(m => m.PartnerUserModule)
  },
  {
    path: 'support-chat', loadChildren: () => import('./modules/support-chat/support-chat.module').then(m => m.SupportChatModule)
  },
  {
    path: 'partnership-firm', loadChildren: () => import('./modules/partnership-firm/partnership-firm.module').then(m => m.PartnershipFirmModule)
  },
  {
    path: 'home-page-new', loadChildren: () => import('./index/home.module').then(m => m.HomeModule)
  },
  {
    path: 'private-limited-company-registration', loadChildren: () => import('./modules/private-limited-company-registration/private-limited-company-registration.module').then(m => m.PrivateLimitedCompanyRegistrationModule)
  },
  {
    path: 'press-and-media', loadChildren: () => import('./modules/press-and-media/press-and-media.module').then(m => m.PressAndMediaModule)
  },
  {
    path: 'faq', loadChildren: () => import('./modules/faq-page/faq-page.module').then(m => m.FaqPageModule)
  },
  {
    path: 'news', loadChildren: () => import('./modules/news-page/news-page.module').then(m => m.NewsPageModule)
  },
  {
    path: 'tds-calculator', loadChildren: () => import('./modules/tds-calculator/tds-calculator.module').then(m => m.TdsCalculatorModule)
  },
  {
    path: 'hra-calculator', loadChildren: () => import('./modules/hra-calculator/hra-calculator.module').then(m => m.HraCalculatorModule)
  },
  {
    path: 'ctc-calculator', loadChildren: () => import('./modules/ctc-calculator/ctc-calculator.module').then(m => m.CtcCalculatorModule)
  },
  {
    path: 'new-tax-regime-and-old-tax-regime', loadChildren: () => import('./modules/new-tax-regime-and-old-tax-regime/new-tax-regime-and-old-tax-regime.module').then(m => m.NewTaxRegimeAndOldTaxRegimeModule)
  },
  {
    path: 'gst', loadChildren: () => import('./modules/basic-of-gst/basic-of-gst.module').then(m => m.BasicOfGstModule)
  },
  {
    path: 'itr-filling', loadChildren: () => import('./index/itr-filling-plan/itr-filling/itr-filling.module').then(m => m.ItrFillingModule)
  },
  {
    path: 'chat-with-consultation', loadChildren: () => import('./modules/chat-with-consultation/chat-with-consultation.module').then(m => m.ChatWithConsultationModule)
  },
  {
    path: 'import-export-code', loadChildren: () => import('./modules/import-export-code/import-export-code.module').then(m => m.ImportExportCodeModule)
  },


  {
    path: "my-offers",
    loadChildren: () =>
      import("./modules/offers/offers.module").then((m) => m.OffersModule),
    canActivate: [AuthGuard],
  },

  {
    path: "userdetailPage",
    loadChildren: () =>
      import("./modules/userdetail-page/userdetail-page.module").then(
        (m) => m.UserdetailPageModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: "chat-form",
    loadChildren: () =>
      import("./modules/chat-form/chat-form.module").then(
        (m) => m.ChatFormModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: "contact-us",
    loadChildren: () =>
      import("./modules/static-pages/contact-us/contact-us.module").then(
        (m) => m.ContactUsModule
      ),
  },

  {
    path: "about-us",
    loadChildren: () =>
      import("./modules/static-pages/about-us/about-us.module").then(
        (m) => m.AboutUsModule
      ),
  },

  {
    path: "pricing-return-policy",
    loadChildren: () =>
      import(
        "./modules/static-pages/pricing-return-policy/pricing-return-policy.module"
      ).then((m) => m.PricingReturnPolicyModule),
  },

  {
    path: "terms",
    loadChildren: () =>
      import("./modules/static-pages/terms/terms.module").then(
        (m) => m.TermsModule
      ),
  },

  {
    path: "shipping-policy",
    loadChildren: () =>
      import(
        "./modules/static-pages/shipping-policy/shipping-policy.module"
      ).then((m) => m.ShippingPolicyModule),
  },
  {
    path: "refund",
    loadChildren: () =>
      import("./modules/static-pages/refund/refund.module").then(
        (m) => m.RefundModule
      ),
  },
  {
    path: "privacy",
    loadChildren: () =>
      import(
        "./modules/static-pages/privacy-policy/privacy-policy.module"
      ).then((m) => m.PrivacyPolicyModule),
  },
  {
    path: "how-it-works",
    loadChildren: () =>
      import("./modules/static-pages/how-it-works/how-it-works.module").then(
        (m) => m.HowItWorksModule
      ),
  },
  {
    path: "chat-window",
    component: ChatWindowComponent,
  },
  {
    path: "preloader",
    component: PreloaderComponent,
  },

  {
    path: "become-an-advisor",
    loadChildren: () =>
      import(
        "./advisor-panel/advisor-registration/advisor-registration.module"
      ).then((m) => m.AdvisorRegistrationModule),
  },
  {
    path: "partner-user",
    loadChildren: () =>
      import("./modules/partner-user/partner-user.module").then(
        (m) => m.PartnerUserModule
      ),
  },
  {
    path: "support-chat",
    loadChildren: () =>
      import("./modules/support-chat/support-chat.module").then(
        (m) => m.SupportChatModule
      ),
  },
  {
    path: "partnership-firm",
    loadChildren: () =>
      import("./modules/partnership-firm/partnership-firm.module").then(
        (m) => m.PartnershipFirmModule
      ),
  },
  {
    path: "home-page-new",
    loadChildren: () => import("./index/home.module").then((m) => m.HomeModule),
  },
  {
    path: "private-limited-company-registration",
    loadChildren: () =>
      import(
        "./modules/private-limited-company-registration/private-limited-company-registration.module"
      ).then((m) => m.PrivateLimitedCompanyRegistrationModule),
  },
  {
    path: "press-and-media",
    loadChildren: () =>
      import("./modules/press-and-media/press-and-media.module").then(
        (m) => m.PressAndMediaModule
      ),
  },
  {
    path: "faq",
    loadChildren: () =>
      import("./modules/faq-page/faq-page.module").then((m) => m.FaqPageModule),
  },
  {
    path: "news",
    loadChildren: () =>
      import("./modules/news-page/news-page.module").then(
        (m) => m.NewsPageModule
      ),
  },
  {
    path: "tds-calculator",
    loadChildren: () =>
      import("./modules/tds-calculator/tds-calculator.module").then(
        (m) => m.TdsCalculatorModule
      ),
  },
  {
    path: "hra-calculator",
    loadChildren: () =>
      import("./modules/hra-calculator/hra-calculator.module").then(
        (m) => m.HraCalculatorModule
      ),
  },
  {
    path: "ctc-calculator",
    loadChildren: () =>
      import("./modules/ctc-calculator/ctc-calculator.module").then(
        (m) => m.CtcCalculatorModule
      ),
  },
  {
    path: "new-tax-regime-and-old-tax-regime",
    loadChildren: () =>
      import(
        "./modules/new-tax-regime-and-old-tax-regime/new-tax-regime-and-old-tax-regime.module"
      ).then((m) => m.NewTaxRegimeAndOldTaxRegimeModule),
  },
  {
    path: "chat-with-consultation",
    loadChildren: () =>
      import(
        "./modules/chat-with-consultation/chat-with-consultation.module"
      ).then((m) => m.ChatWithConsultationModule),
  },
  {
    path: "new-about",
    loadChildren: () =>
      import("./modules/static-pages/about-us-new/about-us-new.module").then(
        (m) => m.AboutUsNewModule
      ),
  },
  {
    path: "event-calender",
    loadChildren: () =>
      import("./modules/event-calender/event-calender.module").then(
        (m) => m.EventCalenderModule
      ),
  },
  {
    path: "event-calender-detail",
    loadChildren: () =>
      import(
        "./modules/event-calender-detail/event-calender-detail.module"
      ).then((m) => m.EventCalenderDetailModule),
  },
  {
    path: "hr-clients",
    loadChildren: () =>
      import("./modules/hr-clients/hr-clients.module").then(
        (m) => m.HrClientsModule
      ),
  },
  {
    path: "gst",
    loadChildren: () =>
      import("./modules/basic-of-gst/basic-of-gst.module").then(
        (m) => m.BasicOfGstModule
      ),
  },
  {
    path: "itr-filling",
    loadChildren: () =>
      import("./index/itr-filling-plan/itr-filling/itr-filling.module").then(
        (m) => m.ItrFillingModule
      ),
  },
  {
    path: "chat-with-consultation",
    loadChildren: () =>
      import(
        "./modules/chat-with-consultation/chat-with-consultation.module"
      ).then((m) => m.ChatWithConsultationModule),
  },
  {
    path: "gst-filing", loadChildren: () =>
      import("./modules/gst-filing/gst-filing.module").then((m) => m.GstFilingModule),
  },
  {
    path: "residential-status-calculator", loadChildren: () =>
      import("./modules/residential-status-calculator/residential-status-calculator.module").then((m) => m.ResidentialStatusCalculatorModule),
  },
  {
    path: "rent-receipts", loadChildren: () =>
      import("./modules/rent-receipts/rent-receipts.module").then((m) => m.RentReceiptsModule),
  },
  {
    path: "tax-tips", loadChildren: () =>
      import("./modules/tax-tips/tax-tips.module").then((m) => m.TaxTipsModule),
  },


];
